<nz-spin [nzSpinning]="loading">
  <div class="table-container">
    <nz-table #relatedDocumentsTable nzSize="small" [nzData]="documents" [nzFrontPagination]="false">
      <thead>
        <tr>
          <th>Tips</th>
          <th>Numurs</th>
          <th>Datums</th>
          <th>Derīgs līdz</th>
          <th *hasPermission="[GroupPermissions.DOCUMENT_EDIT]">Darbības</th>
        </tr>
      </thead>
      <tbody>
        @for (document of relatedDocumentsTable.data; track document.id) {
          <tr>
            <td>{{ document.documentType?.name ? document.documentType.name : '-' }}</td>
            <td>{{ document.number ? document.number : '-' }}</td>
            <td>{{ document.date ? (document.date | date : DATE_FORMAT) : '-' }}</td>
            <td>{{ document.validUntil ? (document.validUntil | date : DATE_FORMAT) : '' }}</td>
            <td>
              <nz-flex nzGap="small">
                <ng-container *hasAnyPermission="[GroupPermissions.DOCUMENT_EDIT, GroupPermissions.DOCUMENT_DELETE]; else viewer">
                  <button
                    *hasPermission="[GroupPermissions.DOCUMENT_EDIT]"
                    nz-button
                    nz-tooltip
                    nzTooltipTitle="Labot dokumentu"
                    nzType="info"
                    (click)="viewOrEditDocument(document, true)"
                    >
                    <span nz-icon nzType="edit" nzTheme="outline"></span>
                  </button>
                  <button *hasPermission="[GroupPermissions.DOCUMENT_DELETE]" nz-button nzDanger (click)="deleteDocument(document)">
                    <i nz-icon nzType="delete"></i>
                  </button>
                </ng-container>
                <ng-template #viewer>
                  <button
                    nz-button
                    nz-tooltip
                    nzTooltipTitle="Skatīt un parakstīt dokumentu"
                    nzType="info"
                    (click)="viewOrEditDocument(document)"
                    >
                    <i nz-icon nzType="folder-open"></i>
                  </button>
                </ng-template>
              </nz-flex>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  </div>
</nz-spin>
